import { Box, Stack, Typography, useTheme } from '@mui/material'
import type { InternalLabelSummary } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { LabelActionMenu } from './LabelActionMenu'
import { useDisplayArea } from './useDisplayArea'

type Props = {
  label: InternalLabelSummary
  onClick: () => void
}

export const LabelCard: FC<Props> = ({ label, onClick }) => {
  const theme = useTheme()
  const { imgRef, containerRef, displayArea, onImageLoad } = useDisplayArea()

  return (
    <Box onClick={onClick} sx={{ cursor: 'pointer' }}>
      <Stack bgcolor="white" boxShadow={1}>
        <Box
          ref={containerRef}
          sx={{
            position: 'relative',
            aspectRatio: '1/1',
            bgcolor: 'action.disabledBackground',
          }}
        >
          <img
            ref={imgRef}
            alt={label.name}
            src={label.labelUrl}
            onLoad={onImageLoad}
            // canvasでこちらの画像を操作するため、クロスオリジンで読み込む必要がある
            crossOrigin="anonymous"
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              objectFit: 'contain',
            }}
          />
          {displayArea &&
            label.areas.map(area => (
              <Box
                key={area.id}
                sx={{
                  position: 'absolute',
                  border: `2px solid ${theme.palette.error.main}`,
                  left: `${displayArea.offsetX + area.x * displayArea.width}px`,
                  top: `${displayArea.offsetY + area.y * displayArea.height}px`,
                  width: `${area.width * displayArea.width}px`,
                  height: `${area.height * displayArea.height}px`,
                }}
              />
            ))}
        </Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          py={1}
          px={2}
        >
          <Typography sx={{ fontSize: 14, color: 'text.primary' }}>
            {label.name}
          </Typography>
          <LabelActionMenu id={label.id} hasAreas={label.areas.length > 0} />
        </Stack>
      </Stack>
    </Box>
  )
}
